import { useState, useContext } from "react";
import { useEffect } from "react"
import { useSearchParams } from 'react-router-dom';
import { getAdRecord, validateEmailLink } from "../services/apiService";
import { PageContext } from './PageContext';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Loader } from "@progress/kendo-react-indicators";
import { adRecord } from "../services/interfaces";
import { useNavigate } from "react-router-dom";
export default function Validate (){


    //Used to validate email links for proofs, insertions, and corrections.

    const [SearchParams] = useSearchParams();
    const params = new URLSearchParams(window.location.search);
    const pdf = params.get('PDF')||"";
    const ad = params.get('AD')||"";
    const pw = params.get('VIEWCODE')||"";
    const act = params.get('ACT')||"";
    const pageContext = useContext(PageContext);
    const [linkValid, setLinkValid]=useState(false);
    const navigate=useNavigate();
    const setSelectedAd=(activeAd:adRecord)=>{
        pageContext?.setSelectedAd(activeAd);
    }

    useEffect(()=>{
        if (linkValid==true){
            console.log(pageContext?.selectedAd);
            var url:string="/ViewProof"
            navigate(url);
        }
    },[linkValid])

    useEffect(()=>{
        if (pageContext?.selectedAd.element!=""){
            setLinkValid(true);
        }
    },[pageContext?.selectedAd])

    useEffect(()=>{
        var element="";
        if (pdf=="" && ad!=""){
            element=ad;
        }else{
            element=pdf;
        }
        if (element!="" && pw!=""){
            validateEmailLink(element,pw).then(user=>{
                if (user!="readonly"){        
                    var url:string = "/?ad=" + element;
                    if (act!=""){
                        url+="&act="+act;
                    }
                    window.location.replace(url);
                }else{

                    const slug=element.replace(".PDF","").replace(".pdf","").replace(".INDD","").replace(".FLA","");
                    getAdRecord(slug).then(ad=>{
                        console.log(ad);
                        if (ad){
                            const activeAd:adRecord=
                            {
                                accountNotes:0,
                                category:ad[0].category,
                                comment:"",
                                comment2:"",
                                completedDeadline:0,
                                cropping1:ad[0].cropping1,
                                currentDeadline:0,
                                customer:ad[0].customer,
                                element:ad[0].element,
                                elementType:ad[0].elementType,
                                epsToPagination:0,
                                expr1:0,
                                file1:ad[0].file1,
                                fileSize1:ad[0].fileSize1,
                                fileSize2:ad[0].fileSize2,
                                firstRun:ad[0].firstRun,
                                groupAdNum:ad[0].groupAd,
                                isCrossSold:ad[0].isCrossSold,
                                materialDeadline:0,
                                materialReceived:0,
                                owner:ad[0].owner,
                                path:"",
                                proofInDeadline:0,
                                proofOutDeadline:0,
                                proofSent:0,
                                pub0:ad[0].pub0,
                                pubDate:0,
                                publishDate:ad[0].publishDate,
                                purgeDate:"",
                                queue:ad[0].queue,
                                rCopyLines:ad[0].rCopyLines,
                                rCopyStatus:ad[0].rCopyStatus,
                                salesman:ad[0].salesman,
                                section:ad[0].section,
                                size:ad[0].size,
                                slug:ad[0].slug,
                                status:ad[0].status,
                                temp1:ad[0].temp1,
                                temp3:ad[0].temp3,
                                temp4:ad[0].temp4,
                                temp5:ad[0].temp5,
                                temp6:ad[0].temp6,
                                tmpChar1:ad[0].tmpChar1,
                                tmpChar2:ad[0].tmpChar2,
                                tmpChar3:ad[0].tmpChar3,
                                tmpInt2:ad[0].tmpInt2,
                                watching:"",
                                assignedBy:"",
                                assignedFullName:"",
                                assignedTo:"",
                                ccSubStatus:"",
                                trafficStatus:"",
                                mmJobName:""
                            }
                            console.log(activeAd);
                            setSelectedAd(activeAd)
                        }
                    });
                }
            });
        }
    },[])

    return(
        <div className="mt-3">
            <div className="dashGrid" style={{height:"85vh"}}>
                <Dialog>
                    <div style={{display:"flex", justifyContent:"center"}}>
                        <Loader themeColor="primary" type="converging-spinner" size="large"/>
                    </div>
                    <h5>Please standby while we validate this link</h5>
                </Dialog>
            </div>
        </div>
    )
}